module.exports = __webpack_public_path__ + "99d9fac47d97ac2dd0d2a5708ad2112f.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Black.ttf
// module id = 983
// module chunks = 0